module.exports = require("../styles/getBladeTheme");


//////////////////
// WEBPACK FOOTER
// external "../styles/getBladeTheme"
// module id = 5
// module chunks = 2